import React, { useState, useEffect } from "react";
import LoginActivity from "./LoginActivity";
import Insights from "./InsightsActivity";
import Connection from "./Connections";
import Valuation from "./ValuationActitvity";
import Dealmaker from "./Dealmaker";
import Pitchdeck from "./PitchDeckActivity";
import AIPitchDeckActivity from "./AIPitchDeckActivity";
import Gd_History from "./Gd_history";
import GD_STARTUPINVITE from "./GlobalDatabase/GDStartupInvite";
import GD_INVESTORINVITE from "./GlobalDatabase/GDInvestorInvite";
import OnlineActivity from "./OnlineActivity";
import Plans from "./NewPlans/plans";
import BullJobLogs from "./JobLogs/jobs";
import EmailLogs from "./EmailLogs/emaillogs";
import SpecificUserActivity from "./ParticularUserActivity";
import getUrlqueries from "../../../Utils/getUrlqueries";
import Feedbacks from "./Feedback";
import AIReviews from "../Pitchdeck/AIReviews";
import AccountReports from "./AccountReports/AccountReports";
import BugReports from "./BugReports/bugReports";
import AllInteractions from "./Interactions/AllInteractions";
import Invoicces from "./Invoices";
import Usage from "./Usage";
import OnboardingResponses from "./OnboardingResponses";
import MaxifyBannerActivity from "./MaxifyBannerActivity";
import { useNavigate } from "react-router-dom";
import "./index.css";
import LoginIcon from "@mui/icons-material/Login";
import WifiIcon from "@mui/icons-material/Wifi";
import ShareIcon from "@mui/icons-material/Share";
import HandshakeIcon from "@mui/icons-material/Handshake";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import ForumIcon from "@mui/icons-material/Forum";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import HistoryIcon from "@mui/icons-material/History";
import BusinessIcon from "@mui/icons-material/Business";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import LayersIcon from "@mui/icons-material/Layers";
import ReceiptIcon from "@mui/icons-material/Receipt";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EmailIcon from "@mui/icons-material/Email";
import FeedbackIcon from "@mui/icons-material/Feedback";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BugReportIcon from "@mui/icons-material/BugReport";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import QuizIcon from "@mui/icons-material/Quiz";
import CampaignIcon from "@mui/icons-material/Campaign";

const NAV_SECTIONS = [
  {
    label: "Activity",
    items: [
      { index: 0, label: "Login Activities", icon: LoginIcon },
      { index: 1, label: "Online Activities", icon: WifiIcon },
      { index: 2, label: "Connection Activities", icon: ShareIcon },
      { index: 12, label: "Dealmaker Activities", icon: HandshakeIcon },
      { index: 13, label: "User Activities", icon: PersonSearchIcon },
      { index: 14, label: "Chat Interactions", icon: ForumIcon },
      { index: 21, label: "Onboarding Responses", icon: QuizIcon },
    ],
  },
  {
    label: "Analytics",
    items: [
      { index: 3, label: "Valuation Activities", icon: AssessmentIcon },
      { index: 4, label: "Pitch Deck Activities", icon: SlideshowIcon },
      { index: 23, label: "AI Pitch Deck Activities", icon: AutoAwesomeIcon },
      { index: 5, label: "Insights Activities", icon: LightbulbIcon },
      { index: 20, label: "AI Reviews", icon: AutoAwesomeOutlinedIcon },
      { index: 22, label: "Maxify Banner Clicks", icon: CampaignIcon },
    ],
  },
  {
    label: "Database",
    items: [
      { index: 7, label: "GD History", icon: HistoryIcon },
      { index: 8, label: "GD Startup Invite", icon: BusinessIcon },
      { index: 9, label: "GD Investor Invite", icon: GroupAddIcon },
    ],
  },
  {
    label: "Plans & Billing",
    items: [
      { index: 6, label: "Plans", icon: LayersIcon },
      { index: 18, label: "Invoices", icon: ReceiptIcon },
      { index: 19, label: "Usage", icon: DataUsageIcon },
    ],
  },
  {
    label: "Logs & Reports",
    items: [
      { index: 10, label: "Cron Jobs", icon: ScheduleIcon },
      { index: 11, label: "Email Logs", icon: EmailIcon },
      { index: 15, label: "Platform Feedbacks", icon: FeedbackIcon },
      { index: 16, label: "Account Reports", icon: AssignmentIcon },
      { index: 17, label: "Bug Reports", icon: BugReportIcon },
    ],
  },
];

const PANEL_MAP = {
  0: LoginActivity,
  1: OnlineActivity,
  2: Connection,
  3: Valuation,
  4: Pitchdeck,
  5: Insights,
  6: Plans,
  7: Gd_History,
  8: GD_STARTUPINVITE,
  9: GD_INVESTORINVITE,
  10: BullJobLogs,
  11: EmailLogs,
  12: Dealmaker,
  13: SpecificUserActivity,
  14: AllInteractions,
  15: Feedbacks,
  16: AccountReports,
  17: BugReports,
  18: Invoicces,
  19: Usage,
  20: AIReviews,
  21: OnboardingResponses,
  22: MaxifyBannerActivity,
  23: AIPitchDeckActivity,
};

function getCurrentLabel(tab) {
  for (const section of NAV_SECTIONS) {
    const found = section.items.find((i) => i.index === tab);
    if (found) return found.label;
  }
  return "User Activity";
}

export default function UserActivity() {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [collapsed, setCollapsed] = useState(false);

  const query = +getUrlqueries("tab");
  useEffect(() => {
    if (query || query === 0) setValue(query);
  });

  const handleSelect = (index) => {
    navigate(`/admin/user-activity?tab=${index}`);
    setValue(index);
  };

  return (
    <div className="ua-layout">
      {/* Fixed sub-sidebar */}
      <aside className={`ua-sidebar${collapsed ? " collapsed" : ""}`}>
        <div className="ua-sidebar-header">
          {!collapsed && <p className="ua-sidebar-title">User Activity</p>}
          <button
            className="sidebar-toggle-btn"
            onClick={() => setCollapsed(!collapsed)}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </button>
        </div>
        <nav className="ua-sidebar-nav">
          {NAV_SECTIONS.map((section) => (
            <div key={section.label} className="ua-nav-section">
              {!collapsed && <p className="ua-nav-section-label">{section.label}</p>}
              {section.items.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.index}
                    className={`ua-nav-item${value === item.index ? " active" : ""}`}
                    onClick={() => handleSelect(item.index)}
                    title={collapsed ? item.label : undefined}
                  >
                    <span className="ua-nav-icon"><Icon /></span>
                    <span className="ua-nav-label">{item.label}</span>
                  </button>
                );
              })}
            </div>
          ))}
        </nav>
      </aside>

      {/* Scrollable content */}
      <main className={`ua-content${collapsed ? " sidebar-collapsed" : ""}`}>
        <div className="ua-content-header">
          <h1 className="ua-content-title">{getCurrentLabel(value)}</h1>
        </div>
        <div className="ua-content-body">
          {(() => { const Panel = PANEL_MAP[value]; return Panel ? <Panel /> : null; })()}
        </div>
      </main>
    </div>
  );
}
